import { render, staticRenderFns } from "./IngredientManage.vue?vue&type=template&id=2589f0af&scoped=true&"
import script from "./IngredientManage.vue?vue&type=script&lang=js&"
export * from "./IngredientManage.vue?vue&type=script&lang=js&"
import style0 from "./IngredientManage.vue?vue&type=style&index=0&id=2589f0af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589f0af",
  null
  
)

export default component.exports